import React from 'react'
import './style.scss'
import { useNavigate } from 'react-router-dom'
import GroupWorkoutsPage from './workouts'

const GroupWorkouts: React.FC = () => {
  const navigate = useNavigate()

  const editWorkout = (id: string) => {
    navigate(`/group-workout/${id}/edit`)
  }

  return <GroupWorkoutsPage editWorkout={editWorkout} />
}

export default GroupWorkouts
